module.exports = __webpack_public_path__ + "static/img/name_logos.b71558b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/name_logos.png
// module id = K0/a
// module chunks = 1